import moment from 'moment';

export const formatDuration = (start, end = null) => {
  // Convert strings to date objects
  let seconds;
  if (end == null) { end = 0; }
  if ((end !== null) && !(end instanceof Date) && isNaN(parseFloat(start))) {
    end = moment(end);
  }
  if ((start !== null) && !(start instanceof Date) && isNaN(parseFloat(start))) {
    start = moment(start);
  }

  // If given start and end, calculate number of seconds between
  if ((start !== null) && (end !== null)) {
    seconds = Math.abs(end - start);
    // If original start date was a date object or string, assume seconds is milliseconds
    if (isNaN(parseFloat(start))) {
      seconds = seconds / 1000;
    }
  } else {
    seconds = start;
  }

  if (seconds === 0) { return '0s'; }

  const hr = Math.floor(seconds/3600);
  const m = parseInt(String(Math.floor((seconds%3600)/60)));
  const s = parseInt(String(seconds%60));

  return (
    (hr > 0 ? `${hr}hr ` : "") + // Hours
    (m > 0 ? `${m}m ` : "") + // Minutes
    (s > 0 ? `${s}s` : "") // Seconds
  ).trim();
}

/**
 * Formats uptime compactly. It'll drop the finer time units as we get to
 * larger time spans.
 */
export const formatUptime = (secs: number | null | undefined): string | null => {
  if (secs == null || Number.isNaN(secs)) {
    return null;
  }
  if (secs < 60) {
    return `${secs}s`;
  }
  const minutes = Math.floor(secs / 60);
  if (minutes < 60) {
    return `${minutes}m ${secs % 60}s`;
  }
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (hours < 48) {
    return `${hours}h ${remainingMinutes}m`;
  }
  const days = Math.floor(hours / 24);
  return `${days}d ${hours % 24}h`;
};

export const Duration = (props) =>
  <span>{formatDuration(props.value)}</span>